import { NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, Inject, TemplateRef, ChangeDetectionStrategy, ChangeDetectorRef, inject, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaintDirective } from '../paint.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { take } from 'rxjs';
import { LocationService } from '../location.service';
import { web } from '../../environments/environment';

export interface ConfirmPopupAction {
  label: string;
  callback?: (dialogRef: MatDialogRef<ConfirmPopupComponent,string>) => any;
  route?: string;
  paint: string;
  close?: boolean;
}

export interface ConfirmPopupInput {
  title: string;
  close?: string;

  template?: TemplateRef<any>;
  html?: string;
  text?: string;

  actions?: ConfirmPopupAction[]; 

  payload?: any;
}

@Component({
  selector: 'confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet, PaintDirective, MatButtonModule, MatIcon]
})
export class ConfirmPopupComponent {
  input = inject<ConfirmPopupInput>(MAT_DIALOG_DATA);
  router = inject(LocationService);
  dialogRef: MatDialogRef<ConfirmPopupComponent,string> = inject(MatDialogRef);

  defaultActions: ConfirmPopupAction[] = [
    {
      label: 'No',
      paint: 'warn',
      close: true
    },
    {
      label: 'Yes',
      paint: 'primary',
      close: true
    }
  ];
  
  constructor() { 
    this.dialogRef.disableClose = true;
    if(this.input.close){
      this.dialogRef.backdropClick().pipe(take(1)).subscribe(() => {
        this.dialogRef.close(this.input.close);
      });
    }
  }

  onClick(action: ConfirmPopupAction){
    if(action.callback){
      action.callback(this.dialogRef);
    }

    if(action.close){
      this.dialogRef.close(action.label);
    }

    if(action.route){
      const url = new URL(web + action.route);

      this.router.navigate([url.pathname], {
        queryParams: url.searchParams,
        fragment: url.hash
      });
    }
  }

}
